import ApiService from "../../../services/ApiService";
import { resolveBackendApiUrl } from "../../../services/ApiBaseUrl";
import { apiFetch } from "../../../services/apiFetch";

async function getInstagram(path) {
    await ApiService.getAccessToken();
    const headers = new Headers(ApiService.init.headers);
    headers.set("Accept", "application/json");

    const url = resolveBackendApiUrl(path);
    const result = await apiFetch(url, {
        method: "GET",
        headers,
    });

    if (!result.ok) {
        throw new Error(`GET ${url} failed (HTTP ${result.status})`);
    }

    return result.json();
}

/** POST /test/instagram/* — Bearer JWT only (puzzle-be/docs/instagram-rest-api.md §1.3, no CSRF). */
async function postInstagram(path, body) {
    await ApiService.getAccessToken();
    const headers = new Headers(ApiService.init.headers);
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");

    const url = resolveBackendApiUrl(path);
    const result = await apiFetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
    });

    const json = await result.json().catch(() => null);
    if (!result.ok) {
        const detail = json?.message || json?.error || `HTTP ${result.status}`;
        throw new Error(typeof detail === "string" ? detail : `POST ${url} failed`);
    }
    if (json && json.code === "FAILURE") {
        throw new Error(json.message || "Instagram request failed");
    }
    return json;
}

const InstagramService = {
    getStatus: () => getInstagram("/test/instagram/status"),

    getMe: () => getInstagram("/test/instagram/me"),

    getDebugToken: () => getInstagram("/test/instagram/debug-token"),

    sendMessage: (recipientId, message) =>
        postInstagram("/test/instagram/send-message", {
            recipientId: recipientId.trim(),
            message: message.trim(),
        }),

    /** POST /test/instagram/post-image — publish to feed (§3.6). */
    postImage: (imageUrl, caption) => {
        const payload = { imageUrl: imageUrl.trim() };
        const trimmedCaption = typeof caption === "string" ? caption.trim() : "";
        if (trimmedCaption) {
            payload.caption = trimmedCaption;
        }
        return postInstagram("/test/instagram/post-image", payload);
    },

    /**
     * POST /test/instagram/create-draft — media container only (not on feed / “Only me”).
     */
    createDraft: (imageUrl, caption) => {
        const payload = { imageUrl: imageUrl.trim() };
        const trimmedCaption = typeof caption === "string" ? caption.trim() : "";
        if (trimmedCaption) {
            payload.caption = trimmedCaption;
        }
        return postInstagram("/test/instagram/create-draft", payload);
    },
};

export default InstagramService;
